import React from 'react';
import '../styles/skills.css';
import '../styles/sections.css';
import aspnetLogo from '../assets/aspnet-logo.png';
import flutterLogo from '../assets/flutter-logo.png';
import reactLogo from '../assets/react-logo.png';

const Skills = () => (
  <div className="skills-section">
    <div className="section-header">
      <h2>SKILLS</h2>
      <div className="underline"></div>
    </div>
    <div className="skills-grid">
      <div><strong>Languages:</strong> C#, Java, C, HTML, CSS, JavaScript, TypeScript, Dart</div>
      <div><strong>Frameworks/Libraries:</strong> React, Angular, Node.js, Flutter, Bootstrap</div>
      <div><strong>Back End:</strong> ASP.NET, Spring Boot, MongoDB, MySQL, NoSQL, Firebase</div>
      <div><strong>Tools:</strong> AWS, Azure, Google Cloud, Heroku, GitHub, GitLab, Jira, Maven, phpMyAdmin</div>
      <div><strong>Development Practices:</strong> Agile Scrum, Unit Testing, OOP, Mobile Development, SDLC</div>
    </div>
    <div className="skills-icons">
      <img src={aspnetLogo} alt="ASP.NET Logo" />
      <img src={flutterLogo} alt="Flutter Logo" />
      <img src={reactLogo} alt="React Logo" />
    </div>
  </div>
);

export default Skills;
